import { AIOppAvailableChart } from '../../charts/AIOppAvailableChart';
import { AIViewRateChart } from '../../charts/AIViewRateChart';
import { ConversionRateChart } from '../../charts/ConversionRateChart';
import { mapRates } from '../../helpers/benchmarking/mapRates';
import { usePracticeRates } from '../../helpers/benchmarking/practiceRates';
import { useProviderRates } from '../../helpers/benchmarking/providerRates';
import { useRegionRates } from '../../helpers/benchmarking/regionRates';
import { Header } from '../Header';

import { AIBenchmarksTable } from './AIBenchmarksTable';

export const AIBenchmarks = () => {
  const filteredProviderRates = useProviderRates({ isDataFiltered: true });
  const practiceRates = usePracticeRates({});
  const regionRates = useRegionRates({});

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full vai-px-8 vai-py-4">
      <Header />
      <div className="vai-flex vai-flex-row vai-justify-between vai-w-full vai-h-full">
        <div className="vai-flex vai-flex-col vai-w-[33%] vai-gap-4">
          <AIOppAvailableChart />
          <AIViewRateChart />
        </div>
        <ConversionRateChart level="DSO" />
      </div>
      <AIBenchmarksTable
        providerRates={
          filteredProviderRates.providerRates?.map((provider) =>
            mapRates(
              provider,
              provider.providerId,
              provider.providerName,
              provider.practiceId,
              provider.practiceName,
            ),
          ) ?? []
        }
        practiceRates={
          practiceRates.practiceRates?.map((practice) =>
            mapRates(practice, practice.practiceId, practice.practiceName),
          ) ?? []
        }
        regionRates={
          regionRates.regionRates?.map((region) =>
            mapRates(region, region.regionId, region.regionName),
          ) ?? []
        }
        isLoading={
          filteredProviderRates.isLoading ||
          practiceRates.isLoading ||
          regionRates.isLoading
        }
      />
    </div>
  );
};
